export const AgruparByProp = (miArray, prop) => {
  if (miArray === undefined || miArray == null || miArray.lenght === 0)
    return [];
  var array = miArray.reduce(function (groups, item) {
    var val = item[prop];
    groups[val] = groups[val] || val;
    return groups;
  }, {});
  return Object.values(array);
};
